









import { defineComponent, PropType } from "@vue/composition-api";
import { SfAccordion } from "@storefront-ui/vue";
import { AccordionItemType } from "~/utils/types";

export default defineComponent({
  components: {
    SfAccordion,
  },
  props:{
        whiteTheme:{
          type: Boolean,
          default: false
        },
        accordionItems:{
            type: Array as PropType<AccordionItemType[]>,
            required: true,
        }
    }
});
